import React from 'react';
import { shape, bool, func, string } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { operations } from 'state/ducks/map';
import { replace } from 'react-router-redux';

import LoadingIndicator from 'components/LoadingIndicator';
import locationShape from 'propTypes/locationShape';
import sortSegments from 'helpers/sortSegments';

import List from '../List';
import ListLabels from '../ListLabels';
import ListItem from '../ListItem';
import SegmentsListItem from '../SegmentsListItem';
import Sorting from '../Sorting';
import EmptyPanelState from '../EmptyPanelState';

const SegmentsQuery = gql`
  query Segments {
    segments {
      id
      status
      expectedTravelTime
      travelTimeIndex
      speedLastHour
      liveSpeed
      to {
        id
        name
      }
      from {
        id
        name
      }
    }
  }
`;

export function Segments({
  data,
  selectEntity,
  enterEntity,
  leaveEntity,
  currentHover,
  location,
  historyReplace,
}) {
  if (data.loading) {
    return <LoadingIndicator />;
  }

  // We don't have any segments yet
  if (!data.segments || data.segments.length === 0) {
    return <EmptyPanelState panelType={'segment'} showLink />;
  }

  // We do have segments, so show 'm!
  return (
    <Sorting
      text="sort by"
      queryValueKey="sort"
      queryOrderKey="order"
      options={[
        {
          label: 'tti',
          queryValue: 'tti',
          initialOrder: 'dsc',
          isDefault: true,
        },
        { label: 'speed', queryValue: 'speed', initialOrder: 'asc' },
      ]}
      location={location}
      historyReplace={historyReplace}
    >
      {({ sortValue, sortOrder }) =>
        <div>
          <ListLabels sortValue={sortValue} location="segment" />
          <List>
            {sortSegments(data.segments, sortValue, sortOrder).map(segment => {
              const { id, status } = segment;
              const isActive = currentHover && currentHover.id === id;

              return (
                <ListItem
                  id={id}
                  key={id}
                  status={status}
                  isActive={isActive}
                  onClick={() => selectEntity({ id, type: 'segment' })}
                  onMouseOver={() => enterEntity({ id, type: 'segment' })}
                  onMouseOut={() => leaveEntity({ id, type: 'segment' })}
                  contentType="segment"
                >
                  <SegmentsListItem segment={segment} sortValue={sortValue} />
                </ListItem>
              );
            })}
          </List>
        </div>}
    </Sorting>
  );
}

Segments.propTypes = {
  data: shape({
    loading: bool.isRequired,
    location: shape({}),
  }).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  currentHover: shape({ id: string.isRequired }),
  location: locationShape.isRequired,
  historyReplace: func.isRequired,
};

const mapStateToProps = ({ map }, ownProps) => ({
  currentHover: map.currentHover,
  ...ownProps,
});

const ConnectedSegmentsWithData = compose(
  connect(mapStateToProps, { ...operations, historyReplace: replace }),
  graphql(SegmentsQuery, {
    options: ({ params }) => ({
      variables: {
        id: params.id,
      },
    }),
  })
)(Segments);

export default ConnectedSegmentsWithData;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/Segments/index.js